<template>
    <div class="speakers-wrapper">
        <div class="swiper speakers-swiper" v-if="list.length">
            <div class="swiper-wrapper">
                <div
                    class="swiper-slide"
                    v-for="(item, index) in list"
                    :key="index"
                >
                    恭喜<strong>{{ item.rolename }}</strong
                    >抽中<strong>{{ item.name }}</strong>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
import "swiper/css";
import Swiper from "swiper";
import { Autoplay } from "swiper/modules";
import { ref, onMounted, nextTick } from "vue";
import { GetSpeakers } from "@/api";
import REWARDS from "@/config/rewards";

// 数据
const list = ref([]);
// 获取滚动数据
const getSpeakers = async () => {
    const res = await GetSpeakers();
    if (res && res.logs.length > 0) {
        res.logs.map((item) => {
            const { rewardid } = item;
            const find = REWARDS.find((item) => item.id === rewardid);
            if (find) {
                item.name = find.name;
            }
        });
        list.value = res.logs;
        nextTick(() => {
            new Swiper(".speakers-swiper", {
                direction: "vertical",
                spaceBetween: 0,
                loop: true,
                simulateTouch: false,
                modules: [Autoplay],
                autoplay: {
                    delay: 2000,
                    disableOnInteraction: false
                }
            });
        });
    }
};

onMounted(() => {
    getSpeakers();
});
</script>

<style lang="scss" scoped>
.speakers-wrapper {
    width: 600px;
    margin: 0px auto;
}
.speakers-swiper {
    height: 54px;
    line-height: 54px;
    .swiper-slide {
        display: flex;
        justify-content: center;
        color: #fdd78c;
        strong {
            color: #0ce717;
            margin: 0px 6px;
            font-weight: bold;
        }
    }
}
</style>
